import { render, staticRenderFns } from "./Boletos.vue?vue&type=template&id=433aded4&scoped=true&"
import script from "./Boletos.vue?vue&type=script&lang=js&"
export * from "./Boletos.vue?vue&type=script&lang=js&"
import style0 from "./Boletos.vue?vue&type=style&index=0&id=433aded4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433aded4",
  null
  
)

export default component.exports